import { render, staticRenderFns } from "./AdminAccountMgrClosure.vue?vue&type=template&id=320cbed8&"
import script from "./AdminAccountMgrClosure.vue?vue&type=script&lang=js&"
export * from "./AdminAccountMgrClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports